import type { ReactNode } from 'react'

export type AtelierTab = 'conversation' | 'build'

type AtelierShellProps = {
  chat: ReactNode
  stage: ReactNode
  loupe: ReactNode
  activeTab: AtelierTab
  onTabChange: (tab: AtelierTab) => void
  isWorking?: boolean
  buildUnread?: boolean
}

export function AtelierShell({
  chat,
  stage,
  loupe,
  activeTab,
  onTabChange,
  isWorking = false,
  buildUnread = false,
}: AtelierShellProps) {
  return (
    <div className="atelier" data-working={isWorking ? 'true' : undefined}>
      <main className="atelier-main" data-active-tab={activeTab}>
        <section
          id="atelier-panel-conversation"
          className="atelier-col atelier-col--chat"
          role="tabpanel"
          aria-labelledby="atelier-tab-conversation"
          aria-label="Conversation"
        >
          {chat}
        </section>
        <section
          id="atelier-panel-build"
          className="atelier-build-workspace"
          role="tabpanel"
          aria-labelledby="atelier-tab-build"
          aria-label="Your build"
        >
          <div className="atelier-col atelier-col--stage">{stage}</div>
          <div className="atelier-col atelier-col--loupe">{loupe}</div>
        </section>
      </main>
      <nav className="atelier-tabbar" role="tablist" aria-label="AI Studio views">
        <button
          id="atelier-tab-conversation"
          type="button"
          role="tab"
          aria-selected={activeTab === 'conversation'}
          aria-controls="atelier-panel-conversation"
          className={`atelier-tab${activeTab === 'conversation' ? ' is-active' : ''}`}
          onClick={() => onTabChange('conversation')}
        >
          <svg
            className="atelier-tab-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M4 6.5A2.5 2.5 0 0 1 6.5 4h11A2.5 2.5 0 0 1 20 6.5v8A2.5 2.5 0 0 1 17.5 17H9l-4 3v-13.5Z" />
          </svg>
          <span>Conversation</span>
        </button>
        <button
          id="atelier-tab-build"
          type="button"
          role="tab"
          aria-selected={activeTab === 'build'}
          aria-controls="atelier-panel-build"
          className={`atelier-tab atelier-tab--build${activeTab === 'build' ? ' is-active' : ''}`}
          onClick={() => onTabChange('build')}
        >
          <svg
            className="atelier-tab-icon"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <circle cx="12" cy="12" r="6" />
            <path d="M9 4h6M9 20h6" />
          </svg>
          <span>Your Build</span>
          {buildUnread ? (
            <span className="atelier-tab-badge" aria-label="Build update ready to review">
              Review
            </span>
          ) : isWorking ? (
            <span className="atelier-tab-badge atelier-tab-badge--working">Live</span>
          ) : null}
        </button>
      </nav>
    </div>
  )
}
